const actionPrefix = "relationshipViewSettings";
const CHANGE_SHOW_IDENTIFIER = `${actionPrefix}:CHANGE_SHOW_IDENTIFIER`;
const CHANGE_SHOW_DATES = `${actionPrefix}CHANGE_SHOW_DATES`;
const CHANGE_SHOW_DURATION = `${actionPrefix}CHANGE_SHOW_DURATION`;
const CHANGE_SHOW_NARRATIVE = `${actionPrefix}CHANGE_SHOW_NARRATIVE`;
const CHANGE_SHOW_SUMMARY = `${actionPrefix}CHANGE_SHOW_SUMMARY`;
const CHANGE_SHOW_INFO_ICONS = `${actionPrefix}CHANGE_SHOW_INFO_ICONS`;
const CHANGE_SHOW_ENTITY_COLOR = `${actionPrefix}CHANGE_SHOW_ENTITY_COLOR`;

export const actionTypes = {
  CHANGE_SHOW_IDENTIFIER,
  CHANGE_SHOW_DATES,
  CHANGE_SHOW_DURATION,
  CHANGE_SHOW_NARRATIVE,
  CHANGE_SHOW_SUMMARY,
  CHANGE_SHOW_INFO_ICONS,
  CHANGE_SHOW_ENTITY_COLOR
};

const changeShowIdentifier = show => {
  return {
    type: CHANGE_SHOW_IDENTIFIER,
    show
  };
};

const changeShowDates = show => {
  return {
    type: CHANGE_SHOW_DATES,
    show
  };
};

const changeShowDuration = show => {
  return {
    type: CHANGE_SHOW_DURATION,
    show
  };
};

const changeShowNarrative = show => {
  return {
    type: CHANGE_SHOW_NARRATIVE,
    show
  };
};

const changeShowSummary = show => {
  return {
    type: CHANGE_SHOW_SUMMARY,
    show
  };
};

const changeShowInfoIcons = show => {
  return {
    type: CHANGE_SHOW_INFO_ICONS,
    show
  };
};

const changeShowEntityColor = show => {
  return {
    type: CHANGE_SHOW_ENTITY_COLOR,
    show
  };
};

export default {
  changeShowIdentifier,
  changeShowDates,
  changeShowDuration,
  changeShowNarrative,
  changeShowSummary,
  changeShowInfoIcons,
  changeShowEntityColor
};
